// extracted by mini-css-extract-plugin
export default {"container":"GradeComponent__container___bCv4U","gradeDiv":"GradeComponent__gradeDiv___j0OuK","gradeCardsDiv":"GradeComponent__gradeCardsDiv___FNoVe"};